import { Guid } from "guid-typescript";

class AccessLog {
    application: string;
    browser: string;
    id: Guid;
    ipAddress: string;
    location: string;
    logged: Date;
    platform: string;
    source: string;
    status: string;
    user: string;

    constructor(data?: Partial<AccessLog>) {
        Object.assign(this, data);

        if (typeof this.logged === "string")
            this.logged = new Date(this.logged);
    }
}

export default AccessLog;